(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mk-commerce-header"]) return;
  try {
    
(function () {
  var menu = document.querySelector('[data-mk-menu]');
  if (!menu) return;
  menu.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || !menu.contains(link) || event.defaultPrevented || !menu.classList.contains('is-open')) return;
    var href = link.getAttribute('href');
    if (!href || href === '#') return;
    var closer = menu.querySelector('[data-mk-close]');
    var opener = document.querySelector('[data-mk-open="menu"]');
    if (!closer) return;
    var wasInert = opener && opener.inert;
    if (opener) opener.inert = true;
    try {
      closer.click();
    } finally {
      if (opener) opener.inert = wasInert;
    }
    var destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin || destination.pathname !== location.pathname || destination.search !== location.search || !destination.hash) return;
    var target = document.getElementById(decodeURIComponent(destination.hash.slice(1)));
    if (!target) return;
    var hadTabindex = target.hasAttribute('tabindex');
    if (!hadTabindex) {
      target.setAttribute('tabindex', '-1');
      target.addEventListener('blur', function () { target.removeAttribute('tabindex'); }, { once: true });
    }
    target.focus({ preventScroll: true });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
